import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BaseSection from '../BaseSection';
import ToggleBox from '../../../ToggleBox';
import MarkdownToHtml from '../../MarkdownToHtml';

const DescriptionSection = memo(({ description, isOneDirection }) => {
  const { t } = useTranslation();

  return (
    <BaseSection classNames="item-section__description">
      <div className="item-section__title">{t('residences.description')}</div>
      <ToggleBox
        classNames="toggle-box--residence"
        isOneDirection={isOneDirection}
        maximumHeight={270}
      >
        <MarkdownToHtml
          markdown={description}
          options={{
            wrapper: 'article',
            forceWrapper: true
          }}
        />
      </ToggleBox>
    </BaseSection>
  );
});

DescriptionSection.displayName = `DescriptionSection`;

DescriptionSection.propTypes = {
  description: PropTypes.string,
  isOneDirection: PropTypes.bool
};

export default DescriptionSection;
